import { Injectable } from '@angular/core';
import { NavigationItem } from './navigation-item.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { NAVIGATION_MENU } from './navigation-menu.const';
import { PermissionCode } from '@shared/common/enums';

@Injectable({
    providedIn: 'root',
})
export class NavigationLoaderService {
    private readonly _items: BehaviorSubject<NavigationItem[]> = new BehaviorSubject<
        NavigationItem[]
    >([]);

    get items$(): Observable<NavigationItem[]> {
        return this._items.asObservable();
    }

    constructor() {
        this.loadNavigation();
    }

    loadNavigation(): void {
        const menu = NAVIGATION_MENU.map((menu) => {
            if (menu.type === 'subheading' && menu.children?.length) {
                menu.permissions = menu.children.reduce((value, item) => {
                    if (item.permissions?.length) {
                        return [...value, ...item.permissions];
                    }

                    return value;
                }, [] as PermissionCode[]);
            }

            return menu;
        });
        this._items.next(menu);
    }
}
